module.exports = __webpack_public_path__ + "/images/logo-cta-estrella-digital.92ddd0c.png";